import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import { selectHoveredItemId } from '../../../store/modules/lists/selectors';
import RouteGetter from '../../../routes/RouteGetter';
import hotKeyConverter from '../../../utility/keyCodeConverter';

const ProjectListRowHotKeyListener = () => {
  const dispatch = useDispatch();
  const projectId = useSelector(selectHoveredItemId);

  useEffect(() => {
    const hotKeyRowListener = (event: KeyboardEvent) => {
      if (projectId !== 0) {
        if (!event.ctrlKey && !event.altKey) {
          if (event.keyCode === hotKeyConverter('s')) {
            event.preventDefault();
            dispatch(push(RouteGetter.get('project').scripts(projectId)));
          } else if (event.keyCode === hotKeyConverter('m')) {
            event.preventDefault();
            dispatch(push(RouteGetter.get('project').media(projectId)));
          }
        }
      }
    };
    window.addEventListener('keydown', hotKeyRowListener);

    return () => {
      window.removeEventListener('keydown', hotKeyRowListener);
    };
  }, [dispatch, projectId]);

  return null;
};

export default ProjectListRowHotKeyListener;
